// Admin-issued credit on a whole conversation. Shared because three packages need
// the exact same vocabulary: cloud-api validates and stores it, admin-dashboard
// renders the picker and the labels, and the reason codes are mirrored by a CHECK
// constraint on conversation_credits.reason (migration 055).
//
// A credited conversation is excluded from every billing aggregate AND hidden from
// the customer's app entirely — see packages/cloud-api/CLAUDE.md §"Crédits de
// conversation".
//
// Adding a reason code here REQUIRES three companion edits, otherwise the insert
// fails at runtime or the picker renders a blank label:
//   1. a migration widening the CHECK on conversation_credits.reason,
//   2. a label in packages/admin-dashboard/src/credit-reason-labels.ts,
//   3. `npm run extract` in packages/admin-dashboard + the French translation.
// Ordered as they should appear in the picker: the product failures support acts on
// first, the internal/commercial cases next, "other" last.
export const CONVERSATION_CREDIT_REASONS = [
    "product_bug",
    "wrong_answer",
    "tool_error",
    "support_investigation",
    "internal_testing",
    "demo",
    "sales_gesture",
    "duplicate_turn",
    "other",
];
export const CONVERSATION_CREDIT_NOTE_MAX_LENGTH = 2000;
export function isConversationCreditReason(value) {
    return (typeof value === "string" &&
        CONVERSATION_CREDIT_REASONS.includes(value));
}
